import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
    providedIn: 'root',
})
export class GlobalStateService {

    private loginTest = signal<boolean>(false);
    loginTest$ = toObservable(this.loginTest);

    setLoginTest(value: boolean) {
        this.loginTest.set(value);
    }
}
